import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import {
  FIRST_MONTH_DISCOUNT_RATE,
  MEMBERSHIP_COLORS,
} from "@/features/pathpick/features/membership/constants";

// 오픈 기념 첫 달 할인 이벤트 배너 — 프로모션 대상(신규 가입)에만 노출되므로 자체 조건 분기는 없다.
function PathPickMembershipPromoBanner() {
  const { t } = useI18nHelper();

  return (
    <Flex
      gap={"10px"}
      alignItems={"baseline"}
      alignSelf={"flex-start"}
      flexWrap={"wrap"}
      padding={"7px 10px"}
      borderRadius={"8px"}
      border={`1px solid ${MEMBERSHIP_COLORS.promoBorder}`}
      background={MEMBERSHIP_COLORS.promoBg}
    >
      <Text textStyle={"body-sm-bold"} color={MEMBERSHIP_COLORS.promoText}>
        {t("membership:event_banner.title", {
          rate: FIRST_MONTH_DISCOUNT_RATE,
        })}
      </Text>
      <Text textStyle={"body-sm-regular"} color={MEMBERSHIP_COLORS.promoText}>
        {t("membership:event_banner.description", {
          rate: FIRST_MONTH_DISCOUNT_RATE,
        })}
      </Text>
    </Flex>
  );
}

export default PathPickMembershipPromoBanner;
